import fetch from 'cross-fetch';
import { encodeParameters } from '@utils/http-util';
import { Logger } from "@utils/logger";

// start polling
// {"status":"fail","errorMessage":"Status is not yet complete.","docAttrList":[]}
// https://test2.axn.iddataweb.com/test-axn-aws/axn/doc/checkasyncstatus.max?asi=50ca71ec-12b9-4021-aa68-753ada840037&_=1586443645089

export const pollForAsyncSuccess = (asi: string, contextPath: string): Promise<any> => {
	const queryParams = {
		url: `${contextPath}/doc/checkasyncstatus.max`,
		asi,
		cacheBuster: new Date().getUTCMilliseconds()
	};

	const { url, ...params } = queryParams;
	const finalUrl = `${url}?${encodeParameters(params)}&cb=${new Date().getTime()}`;

	const request = {
		method: "GET"
	};

	Logger.info(`Polling for async status:  ${finalUrl}`);
	return fetch(finalUrl, request);
	// return fetch("http://localhost:3001/checkasyncstatus")
};
